import { useCallback } from "react";

import { usePitPortClient } from "hooks/pitPort/usePitPortClient";
import { useSwr } from "hooks/pitPort/useSwr";
import { PIT_PORT_PAGINATION_DEFAULT_SIZE } from "pages/PitPort/constants/pagination";
import { formatQueryParams } from "utils/stringUtils";

type SystemNotificationResponse = {
  data: PitPortSystemNotification;
};

type SystemNotificationListResponse = {
  data: {
    data: PitPortSystemNotification[];
    pagination: {
      hasMore: boolean;
      pageIndex: number;
      totalPages: number;
      totalItems: number;
    };
  };
};

export const useFindAllSystemNotification = ({
  keyword,
  order,
  orderBy,
  pageIndex,
  pageSize = PIT_PORT_PAGINATION_DEFAULT_SIZE,
}: {
  pageIndex?: number;
  orderBy?: string;
  order?: string;
  keyword?: string;
  pageSize?: number;
}) => {
  const { data, error } = useSwr<SystemNotificationListResponse>(
    `/system-notification?${formatQueryParams({
      keyword,
      pageSize,
      pageIndex,
      orderBy,
      order,
    })}`
  );

  return {
    data: data?.data.data,
    error,
    pageInfo: data?.data.pagination && {
      hasMore: data.data.pagination.hasMore,
      pageIndex: data.data.pagination.pageIndex,
      totalPages: data.data.pagination.totalPages,
      totalItems: data.data.pagination.totalItems,
    },
  };
};

export const useFindSystemNotificationById = (id: string) => {
  const { data, error } = useSwr<SystemNotificationResponse>(`/system-notification/${id}`);

  return { data: data?.data, error };
};

export const useCreateSystemNotification = () => {
  const client = usePitPortClient();

  const create = useCallback(
    async (data: PitPortSystemNotificationParameter) => {
      return await client.execute({
        method: "POST",
        url: "/system-notification",
        data: data,
      });
    },
    [client]
  );

  return { create };
};
